export default __webpack_public_path__ + "static/media/pexels-cottonbro.9031d726.jpg";